<template>
  <div class="container">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'"></Header>
    <!-- content(s) -->
    <div id="content" style="padding-bottom: 72px;">
      <section>
        <div class="resultMsg error onlyMsg">
          <p class="copy">
            추가 정보가 필요합니다.
          </p>
          <!-- <p class="copy">
            결제정보가 신청자와
            <br />
            <em class="pointC1">
              <span>3</span>
              회
            </em>
            일치하지 않습니다.
          </p> -->
          <p class="desc">상담원이 순차적으로 연락 드리겠습니다.</p>
        </div>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="$router.push('/')">
            확인
          </button>
        </div>
      </section>
    </div>
    <!-- content(e) -->
  </div>
</template>

<script>
export default {
  methods: {
    rental: function() {
      this.$router.replace('/');
    },
  },
};
</script>
